import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Projekt anlegen")
const _hoisted_2 = { class: "w-full h-full max-h-screen flex flex-col justify-between px-4 pb-4" }
const _hoisted_3 = { class: "w-full h-full pt-4 overflow-y-auto" }
const _hoisted_4 = { class: "w-full grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" }
const _hoisted_5 = { class: "w-full flex flex-col" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold" }, "Name:*", -1)
const _hoisted_7 = { class: "w-full flex flex-col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold" }, "Projekt-Typ:*", -1)
const _hoisted_9 = { class: "w-full flex flex-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold" }, "Status:*", -1)
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-zewotherm-grey rounded-xl my-10" }, null, -1)
const _hoisted_13 = { class: "flex justify-between" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold text-xl" }, "Weitere Daten:", -1)
const _hoisted_15 = { class: "font-bold text-xl" }

import { IonPage, IonHeader, IonContent, IonToolbar, IonTitle, IonButtons, IonBackButton, IonModal, IonSelect, IonSelectOption, IonIcon } from '@ionic/vue'
import { useCompany } from '@/store/company';
import { useType } from '@/store/type';
import { useAddProject } from '@/store/addProject'
import { alertController, loadingController } from '@ionic/core'
import SubcustomerInput from '../components/addProjectPage/inputFields/SubcustomerInput.vue'
import ContactInput from '../components/addProjectPage/inputFields/ContactInput.vue'
import AreaInput from '../components/addProjectPage/inputFields/AreaInput.vue'
import CustomerInput from '@/components/addProjectPage/inputFields/CustomerInput.vue'
import SubsidiaryInput from '@/components/addProjectPage/inputFields/SubsidiaryInput.vue'
import ConstructionInput from '@/components/addProjectPage/inputFields/ConstructionInput.vue'
import AdditionalDataInput from '@/components/addProjectPage/inputFields/AdditionalDataInput.vue'
import router from '@/router'
import { useCurrentUser } from '@/store/currentUser'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddProjectPage',
  setup(__props) {

const typeStore = useType()
const companyStore = useCompany()
const addProjectStore = useAddProject()
const currentUserStore = useCurrentUser()

async function saveProject() {
  const loading = await loadingController.create({
    message: 'Bitte warten...',
  })
  await loading.present()

  const response = await addProjectStore.saveProject(companyStore.activeCompany.id.toString(), currentUserStore.currentUser.user.id.toString(), currentUserStore.jwtKey)
  
  if(response) {
    router.replace("/detail/" + response + "/data")
  } else {
    let alertMsg = ""

    for(const res of Object.entries(addProjectStore.errorResponse)) {
      alertMsg = alertMsg + "  " + res[0] + ": " + res[1]
    }

    const alert = await alertController.create({
      message: alertMsg,
      buttons: ['OK']
    })
    await alert.present()
  }


  await loading.dismiss()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    text: "",
                    style: {"--color":"#444444"},
                    "default-href": "/"
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("form", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(addProjectStore).projectActiveData.name) = $event)),
                    enterkeyhint: "next",
                    class: _normalizeClass(["w-full min-h-10 h-10 my-1 bg-zewotherm-lightgrey p-2 font-bold rounded-lg outline-none", [_unref(addProjectStore).errorResponse.name && _unref(addProjectStore).errorResponse.name.length > 0 ? 'border-2 border-red-500' : '']])
                  }, null, 2), [
                    [_vModelText, _unref(addProjectStore).projectActiveData.name]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).errorResponse.name, (errorMsg, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "text-red-500",
                      key: index
                    }, _toDisplayString(errorMsg), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_unref(IonSelect), {
                    onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(addProjectStore).setProjectActiveType($event.target.value))),
                    interface: "popover",
                    enterkeyhint: "next",
                    class: _normalizeClass(["w-full min-h-10 h-10 my-1 bg-zewotherm-lightgrey p-2 font-bold rounded-lg outline-none", [_unref(addProjectStore).errorResponse.type && _unref(addProjectStore).errorResponse.type.length > 0 ? 'border-2 border-red-500' : '']]),
                    value: _unref(addProjectStore).projectActiveData.type
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeStore).projectTypes, (option, index) => {
                        return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                          key: index,
                          value: option.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(option.titel), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class", "value"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).errorResponse.type, (errorMsg, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "text-red-500",
                      key: index
                    }, _toDisplayString(errorMsg), 1))
                  }), 128))
                ]),
                _createVNode(ConstructionInput),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_unref(IonSelect), {
                    modelValue: _unref(addProjectStore).projectActiveData.status,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(addProjectStore).projectActiveData.status) = $event)),
                    interface: "popover",
                    enterkeyhint: "next",
                    class: _normalizeClass(["w-full min-h-10 h-10 my-1 bg-zewotherm-lightgrey p-2 font-bold rounded-lg outline-none", [_unref(addProjectStore).errorResponse.status && _unref(addProjectStore).errorResponse.status.length > 0 ? 'border-2 border-red-500' : '']])
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeStore).statusTypes.filter((option) => option.value !== 'all'), (option, index) => {
                        return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                          key: index,
                          value: option.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(option.titel), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "class"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).errorResponse.status, (errorMsg, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "text-red-500",
                      key: index
                    }, _toDisplayString(errorMsg), 1))
                  }), 128))
                ]),
                _createVNode(CustomerInput),
                (_unref(addProjectStore).projectActiveData.customer !== null)
                  ? (_openBlock(), _createBlock(SubsidiaryInput, { key: 0 }))
                  : _createCommentVNode("", true),
                (_unref(addProjectStore).projectActiveData.customer !== null)
                  ? (_openBlock(), _createBlock(ContactInput, { key: 1 }))
                  : _createCommentVNode("", true),
                _createVNode(AreaInput),
                _createVNode(SubcustomerInput)
              ]),
              (_unref(addProjectStore).projectActiveData.type !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(typeStore).getOneProjectType(_unref(addProjectStore).projectActiveData.type)?.titel), 1)
                    ]),
                    _createVNode(AdditionalDataInput)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (saveProject())),
              type: "button",
              style: _normalizeStyle('background-color: ' + _unref(companyStore).activeCompany.color),
              class: "w-full min-h-10 text-white font-bold rounded-lg cursor-pointer mt-3 active:scale-95 duration-200"
            }, "Speichern", 4)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})